export interface LangText { es: string; en: string }
export interface ExtraField { id: string; label: LangText; value: string }
export interface Template { subject: LangText; intro: LangText }
export interface EmailSettings {
  brand_name: string; brand_color: string; accent_color: string; logo_url: string;
  tagline: LangText; footer: LangText;
  show: { ref: boolean; paid_total: boolean; guests: boolean; yacht: boolean; date: boolean; block: boolean; contact: boolean };
  extra_fields: ExtraField[];
  templates: Record<string, Template>;
}

export const KINDS: [string, string, string][] = [
  ["paid", "Confirmación de pago", "{name} {when}"],
  ["confirmed", "Reserva confirmada (manual)", "{name} {when}"],
  ["contact", "Solicitud recibida", "{name} {when}"],
  ["balance", "Aviso de saldo pendiente", "{name} {remaining} {when}"],
  ["balance_paid", "Pago de saldo recibido", "{name} {last} {rest} {when}"],
  ["refund", "Cancelación / reembolso", "{name} {refund_line} {when}"],
];

export const SHOW_LABELS: [keyof EmailSettings["show"], string][] = [
  ["ref", "Folio"], ["paid_total", "Total pagado / saldo"], ["guests", "Personas"], ["yacht", "Nombre del yate"],
  ["date", "Fecha"], ["block", "Bloque / duración"], ["contact", "Datos de contacto (correo y WhatsApp)"],
];

export const emptyTemplate = (): Template => ({ subject: { es: "", en: "" }, intro: { es: "", en: "" } });
